import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  WithStyles,
  withStyles,
  Divider,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import * as Yup from "yup";
import DateFnsUtils from "@date-io/date-fns";
import * as React from "react";
import { Formik } from "formik";
import { isEmpty } from "../constants/constants";
import { AuthConsumer } from "../routes/AuthContext";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_INPUT: "DIALOG_INPUT",
  DIALOG_ACTION: "DIALOG_ACTION",
  DIALOG_ERROR: "DIALOG_ERROR",
};
export const MODE_TYPE = {
  ADD: "ADD",
  EDIT: "EDIT",
};
const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  number: Yup.string().required("Number is required"),
  type: Yup.string().notRequired(),
  size: Yup.string().notRequired(),
  lastInspectionDate: Yup.string().nullable(true),
  currentInspectionDate: Yup.string().nullable(true),
});
const styles = () => createStyles({});
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  mode: any;
  editData: any;
  companyData?: any;
  handleClose: any;
  handleOnSubmit: any;
}
class AddEquipmentsDialog extends React.Component<Props> {
  state = {
    selectedDate: new Date("2014-08-18T21:11:54"),
    isCurrentInspectionDateAvailable: false,
  };

  renderTextInput = (
    type: String,

    id: any,
    value: any,
    handleChange: any,
    handleBlur: any,
    name: any,
    label: any,
    setFieldValue?: any,
    disabled?: any
  ) => {
    return (
      <div>
        {type === "text" && (
          <TextField
            style={{ margin: 10 }}
            id={id}
            value={value ? value : ""}
            onChange={handleChange}
            onBlur={handleBlur}
            name={name}
            disabled={disabled ? true : false}
            label={label}
            fullWidth
          />
        )}
        {type === "picker" && (
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              style={{ margin: 10 }}
              disableToolbar
              variant="inline"
              format="dd MMM yyyy"
              margin="normal"
              id={id}
              autoOk={true}
              label={label}
              value={value ? value : ""}
              onChange={(e) => setFieldValue(id, e?.toDateString())}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
          </MuiPickersUtilsProvider>
        )}
      </div>
    );
  };
  handleDateChange = (date: any) => {
    this.setState({ selectedDate: date });
  };

  renderAllInputField = (
    values: any,
    handleChange: any,
    handleBlur: any,
    setFieldValue: any
  ) => {
    return (
      <div>
        {this.renderTextInput(
          "text",
          "name",
          values.name,
          handleChange,
          handleBlur,
          "name",
          "Name"
        )}
        {this.renderTextInput(
          "text",
          "number",
          values.number,
          handleChange,
          handleBlur,
          "number",
          "Number"
        )}
        {this.renderTextInput(
          "text",
          "type",
          values.type,
          handleChange,
          handleBlur,
          "type",
          "Type"
        )}
        {this.renderTextInput(
          "text",
          "size",
          values.size,
          handleChange,
          handleBlur,
          "size",
          "Size"
        )}
        {this.renderTextInput(
          "text",
          "lastInspectionDate",
          values.lastInspectionDate,
          handleChange,
          handleBlur,
          "lastInspectionDate",
          "Last inspected",
          "",
          true
        )}
        <FormControlLabel
          style={{ margin: 1 }}
          control={
            <Checkbox
              id={"isCurrentInspectionDateAvailable"}
              name={"isCurrentInspectionDateAvailable"}
              checked={this.state.isCurrentInspectionDateAvailable}
              onChange={(event: any) => {
                this.setState({
                  isCurrentInspectionDateAvailable: event.target.checked,
                });
              }}
              value="isCurrentInspectionDateAvailable"
            />
          }
          label="Add inspection date"
        />
        {this.state.isCurrentInspectionDateAvailable &&
          this.renderTextInput(
            "picker",
            "currentInspectionDate",
            values.currentInspectionDate,
            handleChange,
            handleBlur,
            "currentInspectionDate",
            "Next inspection",
            setFieldValue
          )}
      </div>
    );
  };
  render() {
    const { title, open, handleClose, editData, handleOnSubmit } = this.props;
    return (
      <React.Fragment>
        <AuthConsumer>
          {({ user, accessRules }) => (
            <div>
              <Dialog
                open={open}
                keepMounted={true}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                fullWidth={true}
              >
                <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
                <Divider />
                {/* {editData && editData.number && !isEmpty(editData) ? ( */}
                <DialogContent>
                  <div>
                    <Formik
                      initialValues={
                        !isEmpty(editData) && editData && editData.number
                          ? editData
                          : {
                              name: "",
                              number: "",
                              type: "",
                              size: "",
                              lastInspectionDate: "",
                            }
                      }
                      enableReinitialize={true}
                      validationSchema={validationSchema}
                      validateOnMount={true}
                      onSubmit={() => console.log("this submit is active")}
                    >
                      {({
                        values,
                        handleChange,
                        handleBlur,
                        handleReset,
                        setFieldValue,
                      }) => (
                        <div>
                          {this.renderAllInputField(
                            values,
                            handleChange,
                            handleBlur,
                            setFieldValue
                          )}
                          <DialogActions>
                            <Button
                              onClick={() => {
                                handleReset();
                                handleClose();
                              }}
                            >
                              {"CANCEL"}
                            </Button>
                            <Button
                              type="submit"
                              onClick={() => {
                                handleOnSubmit(values, user, accessRules);
                                handleReset();
                              }}
                            >
                              {"SUBMIT"}
                            </Button>
                          </DialogActions>
                        </div>
                      )}
                    </Formik>
                  </div>
                </DialogContent>
              </Dialog>
            </div>
          )}
        </AuthConsumer>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddEquipmentsDialog);
